// extracted by mini-css-extract-plugin
var _1 = "C_Jv4lz24ABwyyr5HGv7";
var _2 = "ymJ5RxgZRFP1NCFLbsun";
export { _1 as "root", _2 as "root__borderless" }
